import { Box, Divider, ListItem, Stack } from '@mui/material'
import { memo } from 'react'

const ROW_COUNT = 8

function AlertsListSkeleton() {
    return (
        <Box sx={{ width: '100%' }}>
            {Array.from({ length: ROW_COUNT }).map((_, i) => (
                <Box key={i}>
                    <ListItem dense disablePadding sx={{ px: 2, py: 1, flexDirection: 'column', alignItems: 'stretch', gap: 0.5 }}>
                        <Box sx={{ width: '72%', height: 14, borderRadius: 0.5 }} />
                        <Stack direction="row" spacing={0.5} alignItems="center">
                            <Box sx={{ width: 18, height: 18, borderRadius: '50%', flexShrink: 0 }} />
                            <Box sx={{ width: 56, height: 12, borderRadius: 0.5 }} />
                            <Box sx={{ width: 8, height: 12, borderRadius: 0.5 }} />
                            <Box sx={{ width: 48, height: 12, borderRadius: 0.5 }} />
                            <Box sx={{ width: 8, height: 12, borderRadius: 0.5 }} />
                            <Box sx={{ width: 64, height: 12, borderRadius: 0.5 }} />
                        </Stack>
                    </ListItem>
                    {i < ROW_COUNT - 1 ? <Divider /> : null}
                </Box>
            ))}
        </Box>
    )
}

export default memo(AlertsListSkeleton)
